import { Locale } from 'common/enums/locale';

export const isCulture = (
  value: string,
): value is Locale => Object.values<string>(Locale).includes(value);
